import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import { FormGroup, FormControlLabel } from 'material-ui/Form';
import Checkbox from 'material-ui/Checkbox';
import colors from '../../../../config/themeColors';

const styles = ({ spacing: { unit } }) => ({
    root: {
        width: 'calc(100% - 32px)',
        marginLeft: '16px',
        marginRight: '16px',
        color: colors.brownishGrey,
    },
    image: {
        width: '120px',
        height: '120px',
        borderRadius: '50%',
        backgroundColor: colors.white2,
        margin: '32px auto',
    },
    congratulation: {
        fontSize: '32px',
        lineHeight: 1.1,
        color: colors.black,
    },
    congratulationDesc: {
        fontSize: '22px',
        lineHeight: 1.1,
        color: colors.black,
        marginBottom: '16px',
    },
    checkboxes: {
        marginTop: '24px',
        marginBottom: '24px',
    },
    checkbox: {
        height: '32px',
    },
    buttons: {
        marginTop: unit * 2,
        marginBottom: unit * 2,
    },
    text: {
        color: colors.brownishGrey,
    },
    textCenter: {
        textAlign: 'center',
    },
});

function RequestSoftCheck(props) {
    return (
        <div className={props.classes.root}>
            <div className={props.classes.textCenter}>
                <div className={props.classes.image}>
                    &nbsp;
                </div>
                <Typography className={props.classes.congratulation}>
                    Please check
                </Typography>
                <Typography className={props.classes.congratulationDesc}>
                    Dip Summary
                </Typography>
                <Typography className={props.classes.text}>
                    Make sure all data in the next column is correct.
                </Typography>
                <Typography className={props.classes.text}>
                    After clicking &#34;Accept &amp; Continue&#34; you will be not able to return.
                </Typography>
            </div>
            <div className={props.classes.checkboxes}>
                <div>
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    color="primary"
                                    className={props.classes.checkbox}
                                    checked={props.consents.acceptedIncomeCheck}
                                    onChange={() => props.setAcceptedIncomeCheck()}
                                    value="true"
                                />
                            }
                            classes={{ label: props.classes.text }}
                            label="I authorize SGL Fintech to verify Taxable income chceck"
                        />
                    </FormGroup>
                </div>

                <div>
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    color="primary"
                                    className={props.classes.checkbox}
                                    checked={props.consents.acceptedSoftCheck}
                                    onChange={() => props.setAcceptedSoftCheck()}
                                    value="true"
                                />
                            }
                            classes={{ label: props.classes.text }}
                            label="I authorize SGL Fintech to perform Soft Credit Check"
                        />
                    </FormGroup>
                </div>
            </div>
            <Typography className={props.classes.text}>
                By clicking „Accept & Check” you agree to SGL Fintech conducting a soft credit check,
                also known as a Quotation search on your profile. This will not adversely affect
                your credit score and will not be available for other lenders to see, only you.
                If you would like more information on this please click here.
            </Typography>
        </div>
    );
}

RequestSoftCheck.propTypes = {
    classes: PropTypes.object.isRequired,
    consents: PropTypes.object.isRequired,
    setAcceptedIncomeCheck: PropTypes.func.isRequired,
    setAcceptedSoftCheck: PropTypes.func.isRequired,
};

export default withStyles(styles)(RequestSoftCheck);



// WEBPACK FOOTER //
// ./src/app/FormStepper/SoftCheck/components/RequestSoftCheck.js